import { render, staticRenderFns } from "./CouponsSection.vue?vue&type=template&id=38aa7275&scoped=true&"
import script from "./CouponsSection.vue?vue&type=script&lang=js&"
export * from "./CouponsSection.vue?vue&type=script&lang=js&"
import style0 from "./CouponsSection.vue?vue&type=style&index=0&id=38aa7275&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa7275",
  null
  
)

export default component.exports